import {createFileRoute, notFound} from "@tanstack/react-router";
import {throwRedirectToWorkspaceConfigEntry} from "~/utilities/workspaceHomeRoute";
import {hasWorkspaceUiConfig} from "~/workspaceConfig/configRuntime";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/")({
    beforeLoad: ({context}) => {
        const workspaceId = context.workspace.id;
        if (hasWorkspaceUiConfig(workspaceId) === true) {
            throwRedirectToWorkspaceConfigEntry(workspaceId, context.currentWorkspaceUser.templateId);
        }
        throw notFound();
    },
    component: () => null,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
